// app/core/auth/role.utils.ts
export class RoleUtils {
  static currentRoles: string[] | null = null;
}
